<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/rb")
          i.fas.fa-running
          span.ml-1 {{ $t("ui.running_ball") }}
      b-breadcrumb-item
        router-link(to="/rb/rbData")
          i.fas.fa-list
          span.ml-1 {{ $t("ui.rb_data") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-1
              SubmitButton(:loading="loading" icon="icon-reload" :text="$t('ui.refresh')" @click="getRBDataList" size="sm" variant="info")
            div.col-md-3
              b-input-group(size="sm").mb-1
                b-input-group-text(slot="prepend")
                  div.d-flex.justify-content-center.align-items-center
                    label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                      input.switch-input(type="checkbox" v-model="$options.refreshEnabled" @change="toggleRefresh()")
                      span.switch-slider(:data-checked='on' :data-unchecked='off')
                b-input(v-model="refreshTime" type="range" min="3" max="7")
                b-input-group-text(slot="append")
                  div(style="text-transform: none;") {{ refreshTime }} s
            div.col-md-8.text-right
              SubmitButton(
                :loading="loading"
                icon="fas fa-paper-plane"
                :text="$t('ui.send')"
                type="button"
                @click="sendRBData"
                variant="danger"
                size="sm"
                )
        div.card-body
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 50%;" v-columns-resizable)
                  thead
                    tr
                      th
                        span {{ $t('ui.id') }}
                      th
                        span {{ $t("ui.rb_data") }}
                      th.text-right
                        span {{ $t("ui.created_on") }}
                  tbody.clusterize-content
                    tr(v-if="rbDataList.length == 0")
                      td(colspan="3").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in rbDataList")
                      td
                        span {{ item.data_id }}
                      td
                        span {{ decodeRBData(item.rb_data) }}
                        //- b-form-textarea(v-model="item.rb_data_test" rows="15")
                      td.text-right
                        span {{ $moment(item.created_on).format("YYYY-MM-DD, HH:mm:ss") }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    rbDataList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    timerId: null,
    refreshTime: 5,
    refreshUpdate: "",
  }),
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
  },
  created: function() {
    this.$options.refreshEnabled = false;
  },
  mounted: function() {
    this.getRBDataList();
  },
  destroyed: function() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  },
  methods: {
    decodeRBData(str) {
      if (str.includes("<match_list"))
        return "Match List";
      else if (str.includes("<event_list"))
        return "Event List";
      else if (str.includes("<keep_alive"))
        return "Keep Alive";
      else if (str.includes("<testing"))
        return "Testing";

      return "";
    },
    getRBDataList: function() {
      let url = config.getRBRawDataUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.rbdata
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.rbDataList = response.data.tbl_rb_raw_data;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    sendRBData : function() {
      let url = config.sendRBRawDataUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.rbdata
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$snotify.success(this.$t("message.success"));
                this.getRBDataList();
              } else {
                if (this.feedback.status == "requestTooFrequent")
                  this.$helpers.showDialog(this.$t("info"), this.$t("error." + this.feedback.status), "info");
                else
                  this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    toggleRefresh: function() {
      this.startCountDownRefresh();
    },
    startCountDownRefresh: function() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      if (this.$options.refreshEnabled) {
        this.getRBDataList();
        this.timerId = setTimeout(() => {
          this.startCountDownRefresh();
        }, this.refreshTime * 1000);
      } else {
        this.refreshUpdate = "STOPPED";
      }
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>